export default function getTrackProductViewRequestObject(options: { crossStoreProductId: string; variantId: string }) {
  return new Promise((resolve, reject) => {
    if (options.crossStoreProductId.length >= 6) {
      resolve({
        Product: {
          Id: options.crossStoreProductId,
        },
        Variant: {
          Id: options.variantId,
        },
      });
    } else {
      reject("Product ID is too short");
    }
  });
}
